export enum ECancellationAction {
    SuspendMembership,
    CancelMembership,
    BanMember,
    UpdateCancelMembership,
    RevokeCancelMembership
}